<template>
  <div class="nx-seo-inheritable-editor mt-4" v-if="value">

    <template v-for="textField in textFields">
      <nx-seo-field-group :key="textField" :label="$t(`message.seo.${textField}`)" v-if="!isHiddenField(textField)">
        <div slot="fields">
          <nx-seo-inheritable-text-field
            :label="$t('message.seo.forPages')"
            :name="`${textField}ForPages`"
            :value="value[`${textField}ForPages`]"
            :counter="textFieldCounter(textField)"
          ></nx-seo-inheritable-text-field>
          <nx-seo-inheritable-text-field
            v-if="!disableContentFields"
            :label="$t('message.seo.forContents')"
            :name="`${textField}ForContents`"
            :value="value[`${textField}ForContents`]"
            :counter="textFieldCounter(textField)"
          ></nx-seo-inheritable-text-field>
        </div>
        <div slot="inheritableFields">
          <nx-seo-inheritable-text-field
            :label="$t('message.seo.forDescendantPages')"
            :name="`${textField}ForDescendantTaxonPages`"
            :value="value[`${textField}ForDescendantTaxonPages`]"
            :counter="textFieldCounter(textField)"
          ></nx-seo-inheritable-text-field>
          <nx-seo-inheritable-text-field
            v-if="!disableContentFields"
            :label="$t('message.seo.forDescendantContents')"
            :name="`${textField}ForDescendantTaxonContents`"
            :value="value[`${textField}ForDescendantTaxonContents`]"
            :counter="textFieldCounter(textField)"
          ></nx-seo-inheritable-text-field>
        </div>
      </nx-seo-field-group>
    </template>

    <nx-seo-field-group label="Keywords" v-if="!isHiddenField('keywords')">
      <div slot="fields">
        <nx-seo-array-field
          :label="$t('message.seo.forPages')"
          name="keywordsForPages"
          :value="value.keywordsForPages"
          @input="updateField"
        ></nx-seo-array-field>
        <nx-seo-array-field
          v-if="!disableContentFields"
          :label="$t('message.seo.forContents')"
          name="keywordsForContents"
          :value="value.keywordsForContents"
          @input="updateField"
        ></nx-seo-array-field>
      </div>
      <div slot="inheritableFields">
        <nx-seo-array-field
          :label="$t('message.seo.forDescendantPages')"
          name="keywordsForDescendantTaxonPages"
          :value="value.keywordsForDescendantTaxonPages"
          @input="updateField"
        ></nx-seo-array-field>
        <nx-seo-array-field
          v-if="!disableContentFields"
          :label="$t('message.seo.forDescendantContents')"
          name="keywordsForDescendantTaxonContents"
          :value="value.keywordsForDescendantTaxonContents"
          @input="updateField"
        ></nx-seo-array-field>
      </div>
    </nx-seo-field-group>

    <nx-seo-field-group label="Robots" v-if="!isHiddenField('robots')">
      <div slot="fields">
        <nx-seo-robots-field
          :label="$t('message.seo.forPages')"
          name="robotsForPages"
          :value="value.robotsForPages"
          @input="updateField"
        ></nx-seo-robots-field>
        <nx-seo-robots-field
          v-if="!disableContentFields"
          :label="$t('message.seo.forContents')"
          name="robotsForContents"
          :value="value.robotsForContents"
          @input="updateField"
        ></nx-seo-robots-field>
      </div>
      <div slot="inheritableFields">
        <nx-seo-robots-field
          :label="$t('message.seo.forDescendantPages')"
          name="robotsForDescendantTaxonPages"
          :value="value.robotsForDescendantTaxonPages"
          @input="updateField"
        ></nx-seo-robots-field>
        <nx-seo-robots-field
          v-if="!disableContentFields"
          :label="$t('message.seo.forDescendantContents')"
          name="robotsForDescendantTaxonContents"
          :value="value.robotsForDescendantTaxonContents"
          @input="updateField"
        ></nx-seo-robots-field>
      </div>
    </nx-seo-field-group>

    <nx-seo-metas-field
      :label="$t('message.seo.metas.name')"
      name="ownMetas"
      :value="value.ownMetas"
      :inherited-metas="value.inheritedMetas"
      @input="updateField"
      v-if="!isHiddenField('ownMetas')"
    >
    </nx-seo-metas-field>
  </div>
</template>

<script>
import Editor from '@/modules/seo/editor/Editor';
import NxSeoFieldGroup from '@/modules/seo/components/FieldGroup';

export default {
  name: 'nx-seo-taxonomy-editor',
  components: { NxSeoFieldGroup },
  extends: Editor,
  props: {
    disableContentFields: {
      type: Boolean,
    },
    textFields: {
      type: Array,
      default: () => ([
        'title',
        'description',
      ]),
    },
  },
};
</script>
